import React, { Fragment } from 'react';
import {
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowController,
    ShowView,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    FormDataConsumer,
    ArrayInput,
    SimpleFormIterator,
    ReferenceInput,
    ImageField,
    ArrayField,
    BooleanField,
    BooleanInput,
    ImageInput,
    SelectArrayInput,
    NumberInput,
    AutocompleteInput,
    NumberField,
    TopToolbar,
    Toolbar,
    SaveButton,
    useRedirect, useNotify,
    FileInput,
    FileField,
    Show,
    FunctionField,
} from 'react-admin';

import client from '../common/client.js'
import {getLoginToken, getSelectedProject} from '../common/common.js'

import ListSubheader from '@mui/material/ListSubheader';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Button, Box, Link, List as CoreList, Chip, CircularProgress } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import ProjectReferenceInput from '../project/ProjectReferenceInput'

const SketchFilter = props => (
    <Filter {...props}>
        <TextInput resettable label="Sketch Name" source="name" alwaysOn />
    </Filter>
);

export const SketchList = props => {
    return (
        <List title="Sketch" {...props} filters={<SketchFilter />}
            mutationMode='optimistic'
            exporter={false}
            filter={{project_id:getSelectedProject()}}
            sort={{ field: 'name', order: 'ASC' }}>
            <Datagrid>
                <TextField source="id" />
                <TextField label="Sketch Name" source="name" />

                <FunctionField label="Download" render={record => 
                    <Link href={record.sketch_file}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                        >
                            Download Sketch
                        </Button>
                    </Link>
                } />
                <EditButton />
            </Datagrid>
        </List>
    )
};

const SketchTitle = ({ record }) => {
    return <span>Sketch {record ? `"${record.name}"` : ''}</span>;
};

const required = (message = 'Required') =>
    value => value ? undefined : message;
const maxLength = (max, message = 'Too Long') =>
    value => value && value.length > max ? message : undefined;
const validateRequireAndLength = [required(), maxLength(100)];


const PostEditActions = ({ basePath, data, resource }) => (
    <TopToolbar>
        {/* <ShowButton basePath={basePath} record={data} /> */}
        {/* Add your custom actions */}
        <Button color="primary">Custom Action</Button>
    </TopToolbar>
);

const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);


const GenerateAsk = props => {
    const notify = useNotify();
    const redirect = useRedirect();
    const [loading, setLoading] = React.useState(false);
    const [list, setList] = React.useState(props.record.new_screen_list);

    const handleClick = (e) => {
        let udid = props.record.id

        let target_list = list.filter(f => f.selected == 'Y')
        if (target_list.length == 0)
            return alert('Please, select screen')

        setLoading(true)
        let rest_list = list.filter(f => f.selected != 'Y')
        client.request_post(`/api/engine/generate/${udid}`, { target_list: target_list }).then(res => {
            setLoading(false)
            if (res.r) {
                setList(rest_list)
                notify(`Generate Success`);
                redirect(`/sketch/${udid}`);
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }
    return (
        <Box m={1}>
            <Box>Do you want to auto generate following screens? </Box>
            <Box m={1}>{list && list.map(m => (
                <Chip key={m.id} m={1} label={m.name}
                    onClick={() => {
                        m.selected = m.selected == 'Y' ? 'N' : 'Y'
                        let newList = list.map(a => a)
                        setList(newList)
                    }}
                    clickable
                    color={m.selected == 'Y' ? 'primary' : 'default'}
                />
            ))}</Box>
            <Button startIcon={loading && <CircularProgress size={24} />} variant="contained" color="secondary" onClick={handleClick} disabled={loading}>YES</Button>
        </Box>
    )
}

export const SketchCreate = props => (
    <Create redirect="edit" {...props} mutationMode='pessimistic' actions={<PostEditActions />}>
        <SimpleForm toolbar={<PostEditToolbar />}
        >
            <FileInput source="img" label="Sketch File" placeholder={<p>Upload Sketch(should be under 10mb)</p>} validate={[required()]}>
                <FileField source="src" title="title" accept="image/*" />
            </FileInput>
        </SimpleForm>
    </Create>
);

export const SketchEdit = props => (
    <Edit title={<SketchTitle />} {...props} mutationMode='pessimistic' actions={<PostEditActions />}>
        <SimpleForm toolbar={<PostEditToolbar />}
            redirect={`/sketch/${props.id}`}
        >
            {/* <ProjectReferenceInput label="Project" source="project_id" reference="project" validate={validateRequireAndLength}/> */}
            <ReferenceInput label="Project" source="project_id" reference="project">
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <TextInput resettable label="Sketch Name" source="name" validate={validateRequireAndLength} />

            <FormDataConsumer>
                {({ formData, ...rest }) =>
                    (formData.project_id) && (
                        <GenerateAsk record={formData} />
                    )
                }
            </FormDataConsumer>

        </SimpleForm>
    </Edit>
);

export const SketchShow = ({ ...props }) => (
    <Show {...props} title={<SketchTitle />}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label="Sketch Name" source="name" />
        </SimpleShowLayout>
    </Show>
);
